// Everything the pages show about an event besides its texts follows from its
// date: upcoming or past, order, year and the written date in the visitor's
// language.
import eventRegistry from '../config/events.cjs';

const { events } = eventRegistry;

// English dates are written the European way ("10 March 2026").
const dateLocales = { en: 'en-GB' };

const localDay = (date = new Date()) => [
  date.getFullYear(),
  String(date.getMonth() + 1).padStart(2, '0'),
  String(date.getDate()).padStart(2, '0')
].join('-');

const lastDay = (event) => event.endDate || event.date;

const toDate = (isoDay) => {
  const [year, month, day] = isoDay.split('-').map(Number);
  return new Date(year, month - 1, day);
};

// Upcoming events from the nearest on, past events from the latest back.
export const getEvents = (today = localDay()) => {
  const upcoming = events
    .filter((event) => lastDay(event) >= today)
    .sort((a, b) => a.date.localeCompare(b.date));
  const past = events
    .filter((event) => lastDay(event) < today)
    .sort((a, b) => b.date.localeCompare(a.date));
  return { upcoming, past };
};

// The nearest events for the start page: what is coming first, then what was.
export const getNearestEvents = (count) => {
  const { upcoming, past } = getEvents();
  return [...upcoming, ...past].slice(0, count);
};

export const groupByYear = (list) => list.reduce((groups, event) => {
  const year = event.date.slice(0, 4);
  const group = groups.find((entry) => entry.year === year);
  if (group) {
    group.events.push(event);
  } else {
    groups.push({ year, events: [event] });
  }
  return groups;
}, []);

export const formatEventDate = (event, language) => {
  const format = new Intl.DateTimeFormat(dateLocales[language] || language, { day: 'numeric', month: 'long', year: 'numeric' });
  if (event.endDate && event.endDate !== event.date && typeof format.formatRange === 'function') {
    return format.formatRange(toDate(event.date), toDate(event.endDate));
  }
  return format.format(toDate(event.date));
};
